// extracted by mini-css-extract-plugin
export default {"container":"InformationField_container__g5M1y","information":"InformationField_information__nt3J7"};